import React, { useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import {getPriceLabel, routeReplace} from "./utils";
import NumberFormat from "react-number-format";
import moment from "moment";
import { Divider, Grid } from "@material-ui/core";
import { returnStringTranslation } from "./printLanguageSelect";
import parseHtml from "html-react-parser";
import { returnDescriptionById } from "./utils";
import Iframe from "react-iframe";
import { useTheme } from "@material-ui/core";
import { Carousel } from "react-responsive-carousel";
import Dialog from "@material-ui/core/Dialog";
import StarsIcon from "@material-ui/icons/Stars";
import StarBorderIcon from "@material-ui/icons/StarBorder";

import _ from "lodash";
import {
  API_SEARCHER_UNIT_ROUTE, DEAL_TYPE_LEASE_INT, DEAL_TYPE_SALE_INT,
} from "../config/config";
import axios from "axios";
import ConfirmationMessagePopUp from "./broker-views/SuperSearcher/ConfirmationMessagePopUp";
import Auth from "../auth/auth";
import {LanguageContext} from "../containers/languageprovider";

const useRowStyles = makeStyles({
  tableContainer: {
    border: "1px solid #d9d9d9",
    borderRadius: "6px",
  },
  root: {
    "& > *": {
      borderBottom: "solid 1px #d9d9d9",
      padding: "0px 15px",
    },
  },
  tableHead: {
    backgroundColor: "rgb(217, 217, 217, 0.2)",
  },
  mediaParent: {
    height: "250px",
    borderRadius: "6px",
    position: "relative",
    overflow: "hidden",
  },
  ArrowsCarousel: {
    width: "50px",
    height: "50px",
    position: "absolute",
    zIndex: 2,
    top: "calc(50% - 25px)",
    cursor: "pointer",
  },
  imgSlider: {
    width: "100%",
    height: "250px",
    maxHeight: "250px",
    objectFit: "cover",
  },
  imgSliderMobile: {
    width: "100%",
    height: "90vh",
    objectFit: "cover",
  },
  imgSliderModal: {
    width: "100%",
    height: "90vh",
  },
  openFullScreenButton: {
    position: "absolute",
    cursor: "pointer",
    bottom: 0,
    right: 0,
    color: "white",
    zIndex: 9999,
  },
  modalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  },
  overlayMedia: {
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 99,
    backgroundColor: "black",
    opacity: 0.1,
    cursor: "pointer",
  },
  StarIcon: {
    "&:hover": {
      color: "green",
    },
    cursor: "pointer",
  },
  FilledStarIcon: {
    pointerEvents: "none",
    color: "#59c170",
    fontSize: "30px",
  },
});

const UnitsTable = ({
  units,
  lang,
  listTech,
  listComm,
  setFilteredUnits,
  setListUnits,
  portfolio,
  idPopperUnpayed,
  handleMouseEnter,
  handleMouseLeave,
}) => {
  const [open, setOpen] = React.useState(false);
  const [openCarousel, setOpenCarousel] = React.useState(false);
  const [openVirtual, setOpenVirtual] = React.useState(false);
  const [openYoutube, setOpenYoutube] = React.useState(false);
  const [selectedUnit, setSelectedUnit] = React.useState(0);
  const [hasMediaRow, setHasMediaRow] = React.useState(false)
  const classes = useRowStyles();
  const theme = useTheme();
  const fullscreen = !!document.fullscreenElement;
  const { dictionary, userLanguage } = useContext(LanguageContext);

  // console.log(moment().isAfter(moment(), units[0].listing_date));
  // console.log(units);
  // console.log(listTech);

  //Stared unit id
  const [staredSearcherUnitId, setStaredSearcherUnitId] = React.useState("");
  const [priceLabel, setPriceLabel] = React.useState("")

  //Open confirmation message pop up
  const [openConfirmationMessagePopUp, setOpenConfirmationMessagePopUp] =
    React.useState(false);

  function isDateAfterToday(date) {
    return moment(date).isAfter(moment());
  }

  const getImageGalleryArray = (images) => {
    return images.map((img) => ({
      original: img.image,

      originalHeight: "300px",
      originalWidth: "100%",
      // thumbnailClass: classes.image,
    }));
  };

  units = units.sort((a, b) => Number(a.floor) - Number(b.floor));

  // useEffect(() => {
  //   console.log("UnitsTable :", units);
  // }, [units]);

  useEffect(() => {
    if(units?.length > 0) {
    const checkHasMediaRow = units.some(unit => {
      return (
          (unit?.images?.length > 0) ||
          unit.video ||
          unit.virtual_tour ||
          unit.description ||
          unit.technical_features ||
          (unit.technical_features !== "") ||
          (unit.commercial_features !== null && unit.commercial_features !== "") ||
          (unit?.docs?.length > 0)
      );
    });

    setHasMediaRow(checkHasMediaRow);}


  }, [units]);


  const hasSearcherUnit = (units) => {
    let hasSearcherUnitObject = false;
    units.map((unit) => {
      if (unit.searcher_unit) {
        hasSearcherUnitObject = Object.keys(unit.searcher_unit).length > 0;
      }
    });
    return hasSearcherUnitObject;
  };

  //open the confimration message pop up
  const openConfirmationMessagePopUpHandler = (staredSearcherUnitId) => {
    setStaredSearcherUnitId(staredSearcherUnitId);
    setOpenConfirmationMessagePopUp(true);
  };

  //close the confimration message pop up
  const hideConfirmationMessagePopUp = () => {
    setOpenConfirmationMessagePopUp(false);
  };

  //confirm Staring Unit
  const confirmStarUnitHandler = () => {
    const unit = units.filter(
      (unit) => unit.searcher_unit.id === staredSearcherUnitId
    );
    console.log("before confirmStarUnitHandler searcherUnit : ", unit);

    if (unit) {
      console.log(
        "confirmStarUnitHandler searcherUnit : ",
        unit[0].searcher_unit
      );
      axios
        .patch(
            routeReplace(API_SEARCHER_UNIT_ROUTE,{searcherId: staredSearcherUnitId}),
          { seen_at: unit[0].searcher_unit.seen_at, star: 1 },
          {
            headers: {
              Authorization: "Bearer " + Auth.getToken(),
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log("data : ", res.data);
          const updatedUnits = units.map((unit) => {
            if (unit.searcher_unit.id === staredSearcherUnitId) {
              console.log(
                "update searcher_offerors : ",
                res.data.searcher_offerors
              );
              return {
                ...unit,
                searcher_unit: {
                  ...unit.searcher_unit,
                  star: 1,
                },
              };
            }
            return unit;
          });
          console.log("updatedSearcherUnits : ", updatedUnits);

          setFilteredUnits(updatedUnits);
          setListUnits(updatedUnits);
          hideConfirmationMessagePopUp();
        });
    }
  };







  return (
    <>
      <TableContainer className={classes.tableContainer}>
        <Table style={{ overflow: "hidden" }} aria-label="collapsible table">
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell style={{ fontWeight: 600 }}>
                {_.upperCase(dictionary.solution)}
              </TableCell>
              <TableCell style={{ fontWeight: 600 }}>
                {_.upperCase(dictionary.Size)}
              </TableCell>
              <TableCell style={{ fontWeight: 600 }}>
                {_.upperCase(dictionary.Price)}
              </TableCell>
              <TableCell style={{ fontWeight: 600 }}>
                {_.upperCase(dictionary.deal)}
              </TableCell>
              <TableCell style={{ fontWeight: 600 }}>
                {_.upperCase(dictionary.asset)}
              </TableCell>
              <TableCell style={{ fontWeight: 600 }}>
                {_.upperCase(dictionary.Available)}
              </TableCell>
              {hasSearcherUnit(units) && (
                <TableCell style={{ fontWeight: 600 }}>
                  <StarBorderIcon />
                </TableCell>
              )}

              <TableCell>
                <img src="/images/ico/docIcon.svg" width={17} />
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {units.map((unit, i) => (
              <>
                <TableRow key={i} className={classes.root}>
                  <TableCell component="th" scope="row">
                    {unit.info.getFloorLabel(lang)}
                    {/*{getFloorText(unit.floor, dictionary, lang)}*/}
                  </TableCell>
                  <TableCell>
                    <NumberFormat
                      fixedDecimalScale="true"
                      decimalScale="2"
                      value={unit.size}
                      type="text"
                      displayType="text"
                      thousandSeparator={lang === "gb" ? "," : "'"}
                    />{" "}
                    {lang === "gb" ? "Mq" : "m²"}
                  </TableCell>
                  <TableCell>
                    {unit && unit.info.calculateUnitPrice(userLanguage)}
                  </TableCell>
                  <TableCell>
                    {unit.deal_type === DEAL_TYPE_SALE_INT && dictionary.sale}
                    {unit.deal_type === DEAL_TYPE_LEASE_INT && dictionary.lease}
                  </TableCell>
                  <TableCell>
                    {unit.asset_class === 1 && dictionary.Office}
                    {unit.asset_class === 2 && dictionary.Retail}
                    {unit.asset_class === 3 && dictionary.Industrial}
                  </TableCell>
                  {!portfolio && (
                      <TableCell>{unit.info?.getUnitStatus(lang)}</TableCell>
                  )}
                  {portfolio && (
                      <TableCell>{unit.info?.getUnitStatus(lang)}</TableCell>
                  )}
                  {hasSearcherUnit(units) && (
                    <TableCell>
                      {unit.searcher_unit?.star === 0 && (
                        <StarBorderIcon
                          onClick={() =>
                            openConfirmationMessagePopUpHandler(
                              unit.searcher_unit?.id
                            )
                          }
                          className={classes.StarIcon}
                        />
                      )}
                      {unit.searcher_unit?.star === 1 && (
                        <StarsIcon className={classes.FilledStarIcon} />
                      )}
                      { unit.searcher_unit?.star === null && <StarBorderIcon
                          dataId={idPopperUnpayed}
                          onMouseEnter={handleMouseEnter}
                          onMouseLeave={handleMouseLeave}
                          style={{ maxHeight: "30px" }}
                          className={classes.StarIcon}
                      />}

                    </TableCell>
                  )}
                  <TableCell>
                    {unit.docs?.length > 0 ? unit.docs?.length : "-"}
                  </TableCell>
                  <TableCell>
                    {hasMediaRow &&
                    <IconButton
                      aria-label="expand row"
                      onClick={() => {
                        if (open !== i) {
                          setOpen(i);
                        } else {
                          setOpen(null);
                        }
                      }}
                    >
                      {open === i ? (
                        <KeyboardArrowUpIcon style={{ color: "#000" }} />
                      ) : (
                        <KeyboardArrowDownIcon />
                      )}
                    </IconButton>}
                  </TableCell>
                </TableRow>
                {open === i && (
                  <TableRow>
                    <TableCell colSpan={8}>
                      <Collapse in={open === i} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                          <Grid container direction="column" spacing={2}>
                            <Grid container item spacing={2}>
                              {unit?.images?.length > 0 && (
                                <Grid
                                  xs={unit.video && unit.virtual_tour ? 12 : 6}
                                  item
                                >
                                  <div
                                    style={{
                                      borderRadius: "6px",
                                      overflow: "hidden",
                                      position: "relative",
                                    }}
                                  >
                                    <div
                                      onClick={() => {
                                        setSelectedUnit(i);
                                        setOpenCarousel(true);
                                      }}
                                      className={classes.overlayMedia}
                                    ></div>
                                    <Carousel
                                      centerMode={true}
                                      centerSlidePercentage={100}
                                      showIndicators={false}
                                      showThumbs={false}
                                      autoPlay={false}
                                      swipeable={true}
                                      dynamicHeight={false}
                                      infiniteLoop={true}
                                      showStatus={false}
                                      renderArrowPrev={(
                                        onClickHandler,
                                        hasPrev,
                                        label
                                      ) =>
                                        hasPrev && (
                                          <div
                                            className={classes.ArrowsCarousel}
                                            onClick={onClickHandler}
                                            style={{ left: 0 }}
                                          >
                                            {" "}
                                            <img
                                              src="/images/ico/LeftArrowCarousel.svg"
                                              height={50}
                                            />
                                          </div>
                                        )
                                      }
                                      renderArrowNext={(
                                        onClickHandler,
                                        hasNext,
                                        label
                                      ) =>
                                        hasNext && (
                                          <div
                                            className={classes.ArrowsCarousel}
                                            onClick={onClickHandler}
                                            style={{ right: 0 }}
                                          >
                                            <img
                                              src="/images/ico/RightArrowCarousel.svg"
                                              height={50}
                                            />
                                          </div>
                                        )
                                      }
                                    >
                                      {unit.images?.map((item, index) => (
                                        <div className={classes.boxSlider}>
                                          <img
                                            key={index}
                                            className={classes.imgSlider}
                                            alt={returnStringTranslation(
                                              item.description,
                                              lang
                                            )}
                                            src={item.image}
                                          />
                                        </div>
                                      ))}
                                    </Carousel>
                                  </div>
                                </Grid>
                              )}
                              {unit.video && (
                                <Grid xs={6} item>
                                  <div className={classes.mediaParent}>
                                    <div
                                      onClick={() => {
                                        setSelectedUnit(i);
                                        setOpenYoutube(true);
                                      }}
                                      className={classes.overlayMedia}
                                    ></div>
                                    <Iframe
                                      url={unit.video}
                                      width="100%"
                                      height="100%"
                                      allowFullScreen
                                      frameBorder={0}
                                      display="initial"
                                      position="relative"
                                    />
                                  </div>
                                </Grid>
                              )}
                              {unit.virtual_tour && (
                                <Grid xs={6} item>
                                  <div className={classes.mediaParent}>
                                    <div
                                      onClick={() => {
                                        setSelectedUnit(i);
                                        setOpenVirtual(true);
                                      }}
                                      className={classes.overlayMedia}
                                    ></div>
                                    <Iframe
                                      url={unit.virtual_tour}
                                      width="100%"
                                      height="100%"
                                      allowFullScreen
                                      frameBorder={0}
                                      display="initial"
                                      position="relative"
                                    />
                                  </div>
                                </Grid>
                              )}
                            </Grid>
                            <Grid item>
                              {unit.description !== "" && (
                                <Grid container spacing={3}>
                                  <Grid item md={12} xs={12}>
                                    {parseHtml(
                                      returnStringTranslation(
                                        unit.description,
                                        lang
                                      )
                                    )}
                                  </Grid>
                                </Grid>
                              )}
                            </Grid>
                            <Grid container spacing={2} item>
                              <Grid xs={6} item>
                                <Grid container spacing={2}>
                                {unit.technical_features !== null &&
                                  unit.technical_features !== "" && (
                                        <>
                                        {unit.technical_features
                                        .split(",")
                                        .map(Number)
                                        .map((item) => {
                                          if (
                                            returnDescriptionById(
                                              item,
                                              listTech,
                                              lang
                                            ) !== ""
                                          )
                                            return (
                                                <Grid item xs={12}>

                                                <Grid
                                                  container
                                                  alignItems="center"
                                                  spacing={1}
                                                  style={{
                                                    margin: "0 3px",
                                                  }}
                                              >
                                                <Grid item>
                                                  <img src="/images/ico/FeatureDot.svg" />
                                                </Grid>
                                                <Grid item>
                                                  {returnDescriptionById(
                                                    item,
                                                    listTech,
                                                    lang
                                                  )}
                                                </Grid>
                                              </Grid>
                                                </Grid>
                                            );
                                          else return <></>;
                                        })}
                                        </>
                                  )}
                                </Grid>
                              </Grid>
                              <Grid xs={6} item>
                                <Grid container spacing={2}>
                                {unit.commercial_features !== null &&
                                  unit.commercial_features !== "" && (
                                        <>
                                        {unit.commercial_features
                                        .split(",")
                                        .map(Number)
                                        .map((item) => {
                                          if (
                                            returnDescriptionById(
                                              item,
                                              listComm,
                                              lang
                                            ) !== ""
                                          )
                                            return (
                                                <Grid item xs={12}>
                                              <Grid
                                                  container
                                                  alignItems="center"
                                                  spacing={1}
                                                  style={{
                                                    margin: "0 3px",
                                                  }}
                                              >
                                                <Grid item>
                                                  <img src="/images/ico/FeatureDot.svg" />
                                                </Grid>
                                                <Grid item>
                                                  {returnDescriptionById(
                                                    item,
                                                    listComm,
                                                    lang
                                                  )}
                                                </Grid>
                                              </Grid>
                                                </Grid>
                                            );
                                          else return <></>;
                                        })}
                                    </>
                                  )}
                                </Grid>
                              </Grid>
                              {unit.service_charges > 0 && (
                                <Grid item xs={6}>
                                  <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                    style={{
                                      margin: "0 3px",
                                    }}
                                  >
                                    <Grid item>
                                      <img src="/images/ico/FeatureDot.svg" />
                                    </Grid>
                                    <Grid item>
                                      {`${dictionary.serviceCharges} : € ${unit.service_charges}`}
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                              {unit.sublet > 0 && (
                                <Grid item xs={6}>
                                  <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                    style={{
                                      margin: "0 3px",
                                    }}
                                  >
                                    <Grid item>
                                      <img src="/images/ico/FeatureDot.svg" />
                                    </Grid>
                                    <Grid item>{`${dictionary.Sublet}`}</Grid>
                                  </Grid>
                                </Grid>
                              )}
                              {unit.investment > 0 && (
                                <Grid item xs={6}>
                                  <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                    style={{
                                      margin: "0 3px",
                                    }}
                                  >
                                    <Grid item>
                                      <img src="/images/ico/FeatureDot.svg" />
                                    </Grid>
                                    <Grid
                                      item
                                    >{`${dictionary.Investment}`}</Grid>
                                  </Grid>
                                </Grid>
                              )}
                              {unit.business > 0 && (
                                <Grid item xs={6}>
                                  <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                    style={{
                                      margin: "0 3px",
                                    }}
                                  >
                                    <Grid item>
                                      <img src="/images/ico/FeatureDot.svg" />
                                    </Grid>
                                    <Grid item>{`${dictionary.Business}`}</Grid>
                                  </Grid>
                                </Grid>
                              )}
                              {unit.coworking > 0 && (
                                <Grid item xs={6}>
                                  <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                    style={{
                                      margin: "0 3px",
                                    }}
                                  >
                                    <Grid item>
                                      <img src="/images/ico/FeatureDot.svg" />
                                    </Grid>
                                    <Grid
                                      item
                                    >{`${dictionary.Coworking}`}</Grid>
                                  </Grid>
                                </Grid>
                              )}
                              {unit.renovation_status > 0 &&
                              <Grid item xs={6}>
                                <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                    style={{
                                      margin: "3px",
                                    }}
                                >
                                  <Grid item>
                                    <img src="/images/ico/FeatureDot.svg" />
                                  </Grid>
                                  <Grid item>
                                    {`${dictionary.RenovationStatus} : ${unit.info.getRenovationStatusLabel(userLanguage)}`}
                                  </Grid>
                                </Grid>
                              </Grid>}
                              {unit.renovationdate &&
                              <Grid item xs={6}>
                                <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                    style={{
                                      margin: "3px",
                                    }}
                                >
                                  <Grid item>
                                    <img src="/images/ico/FeatureDot.svg" />
                                  </Grid>
                                  <Grid item>
                                    {`${dictionary.RenovationDate} : ${unit.renovationdate}`}
                                  </Grid>
                                </Grid>
                              </Grid>}
                              <Grid item xs={6}>
                                <Grid
                                  container
                                  alignItems="center"
                                  spacing={1}
                                  style={{
                                    margin: "3px",
                                  }}
                                >
                                  <Grid item>
                                    <img src="/images/ico/FeatureDot.svg" />
                                  </Grid>
                                  <Grid item>
                                    {`${dictionary.Grade} :  ${unit.info.getGradeLabel(userLanguage)}`}
                                  </Grid>
                                </Grid>
                              </Grid>

                                {unit.size_terraces &&
                                    <Grid item xs={6}>
                                      <Grid
                                          container
                                          alignItems="center"
                                          spacing={1}
                                          style={{
                                            margin: "3px",
                                          }}
                                      >
                                        <Grid item>
                                          <img src="/images/ico/FeatureDot.svg" />
                                        </Grid>
                                        <Grid item>
                                          {dictionary.Rooftoparea}
                                          {unit.size_terraces > 0 &&
                                              <>
                                              {` : ${unit.size_terraces} ${dictionary.sqm}`}
                                              </>
                                          }
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                }

                                {unit.size_archive &&
                                    <Grid item xs={6}>
                                      <Grid
                                          container
                                          alignItems="center"
                                          spacing={1}
                                          style={{
                                            margin: "3px",
                                          }}
                                      >
                                        <Grid item>
                                          <img src="/images/ico/FeatureDot.svg" />
                                        </Grid>
                                        <Grid item>
                                          {dictionary.ExclusiveArchive}
                                          {unit.size_archive > 0 &&
                                              <>
                                                {` : ${unit.size_archive} ${dictionary.sqm}`}
                                              </>
                                          }
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                }
                                {unit.divisible > 0 && (
                                    <Grid item xs={6}>
                                      <Grid
                                          container
                                          alignItems="center"
                                          spacing={1}
                                          style={{
                                            margin: "0 3px",
                                          }}
                                      >
                                        <Grid item>
                                          <img src="/images/ico/FeatureDot.svg" />
                                        </Grid>
                                        <Grid
                                            item
                                        >{`${dictionary.Divisible}`}</Grid>
                                      </Grid>
                                    </Grid>
                                )}

                              </Grid>


                            </Grid>

                            {unit?.docs?.length > 0 && (
                              <>
                                <Divider />

                                <Grid
                                  style={{
                                    marginTop: "10px",
                                    marginLeft: "0px",
                                  }}
                                  container
                                  spacing={2}
                                >
                                  {unit?.docs?.map((doc) => (
                                    <Grid
                                      xs={6}
                                      // style={{ margin: "0 2px" }}
                                      item
                                      container
                                      alignItems="center"
                                      spacing={1}
                                    >
                                      <Grid item>
                                        <img src="/images/ico/UnitDownloadIcon.svg" />
                                      </Grid>
                                      <Grid item>
                                        <a
                                          target="_blank"
                                          href={doc.doc}
                                          style={{
                                            display: "block",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            maxWidth: "200px",
                                            color: "#1c55e5",
                                            textDecoration: "none",
                                          }}
                                        >
                                          {doc.description ? (
                                            <>
                                              {returnStringTranslation(
                                                doc.description,
                                                lang
                                              ) + ".pdf"}
                                            </>
                                          ) : (
                                            <>{dictionary.documentUnit}</>
                                          )}
                                        </a>
                                      </Grid>
                                    </Grid>
                                  ))}
                                </Grid>
                              </>
                            )}
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                )}
              </>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <ConfirmationMessagePopUp
        openConfirmationMessagePopUp={openConfirmationMessagePopUp}
        hideConfirmationMessagePopUp={hideConfirmationMessagePopUp}
        confirmStarUnitHandler={confirmStarUnitHandler}
      />
      <Dialog
        fullWidth
        maxWidth="lg"
        open={openCarousel}
        onClose={() => setOpenCarousel(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <Carousel
          centerMode={true}
          centerSlidePercentage={100}
          showIndicators={false}
          showThumbs={false}
          autoPlay={false}
          swipeable={true}
          dynamicHeight={false}
          infiniteLoop={true}
          showStatus={false}
          renderArrowPrev={(onClickHandler, hasPrev, label) =>
            hasPrev && (
              <div
                className={classes.ArrowsCarousel}
                onClick={onClickHandler}
                style={{ left: 0 }}
              >
                <img src="/images/ico/LeftArrowCarousel.svg" />
              </div>
            )
          }
          renderArrowNext={(onClickHandler, hasNext, label) =>
            hasNext && (
              <div
                className={classes.ArrowsCarousel}
                onClick={onClickHandler}
                style={{ right: 0 }}
              >
                {" "}
                <img src="/images/ico/RightArrowCarousel.svg" />
              </div>
            )
          }
        >
          {units[selectedUnit]?.images?.map((item, index) => (
            <div className={classes.boxSlider}>
              <img
                key={index}
                className={classes.imgSliderModal}
                alt={returnStringTranslation(item.description, lang)}
                src={item.image}
              />
            </div>
          ))}
        </Carousel>
      </Dialog>
      <Dialog
        fullWidth
        maxWidth="lg"
        open={openVirtual}
        onClose={() => setOpenVirtual(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <Box style={{ height: "80vh", overflow: "hidden" }}>
          <Iframe
            url={units[selectedUnit]?.virtual_tour}
            width="100%"
            height="100%"
            allowFullScreen
            frameBorder={0}
            display="initial"
            position="relative"
          />
        </Box>
      </Dialog>
      <Dialog
        fullWidth
        maxWidth="lg"
        open={openYoutube}
        onClose={() => setOpenYoutube(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <Box style={{ height: "80vh", overflow: "hidden" }}>
          <Iframe
            url={units[selectedUnit]?.video}
            width="100%"
            height="100%"
            allowFullScreen
            frameBorder={0}
            display="initial"
            position="relative"
          />
        </Box>
      </Dialog>
    </>
  );
};

export default UnitsTable;
